import React from "react";
import "./WalletCard.scss";
import {MDBContainer} from "mdbreact";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletDataQuery from "../../queries/WalletData";
import {AddWalletData, setActivePage} from "../../Actions";
import {compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Fade, Slide, Zoom} from 'react-reveal'
import {numberFormat} from "../../util";
import {assetUrl} from "../../serviceApi";

const landingBannerCoin = assetUrl + 'images/animation_landing-banner-coin.svg'
const landingBannerWallet = assetUrl + 'images/animation_landing-banner-wallet.svg'
const landingBannerBase = assetUrl + 'images/animation_landing-banner-base.svg'
const banner_coin_right = assetUrl + 'images/animation_wallet_banner_coin_right.svg'
const banner_coin_left = assetUrl + 'images/animation_wallet_banner_coin_left.svg'
const banner_base = assetUrl + 'images/animation_wallet_banner_base.svg'
const banner_wallet = assetUrl + 'images/animation_wallet_banner_wallet.svg'
const walletCircles = assetUrl + 'images/wallet_circles.png'
const info = assetUrl + 'images/info-icon.svg'
const walletCircles1 = assetUrl + "images/wallet-card-new-dots-1.png"
const walletCircles2 = assetUrl + "images/wallet-card-new-dots-2.png"
const path1 = assetUrl + "images/wallet-path-new.png"

class WalletCard extends React.Component {
	constructor(props) {
		super(props);
		// this.state = {
		// 	walletData: {},
		// }
	}

	//
	// componentDidMount() {
	// 	this.getWalletData();
	// }

	// getWalletData = () => {
	// 	let variables = {
	// 		userId: this.props.user_details.user.id
	// 	}
	// 	fetchQuery(environment, WalletDataQuery, variables)
	// 		.toPromise()
	// 		.then(response => {
	// 			if (response.allWallet !== null && response.allWallet.edges.length > 0) {
	//
	// 				this.props.setWalletData(response.allWallet.edges[0].node);
	// 				this.setState({
	// 					walletData: response.allWallet.edges[0].node
	// 				})
	// 			}
	// 		}, err => {
	// 			console.log(err);
	// 			this.setState({
	//
	// 				walletData: {}
	// 			})
	// 		});
	// }

	render() {
		const {walletData} = this.props
		return (
			<MDBContainer
				className={`wallet-card-component  ${this.props.page === "main" ? "dot-pattern py-4 px-4" : "curve-path-bg py-3"}`}>
				{this.props.page === "wallet" ?
					<>
						<div className={"wallet-circles"}><Zoom><img alt={"alt"} src={walletCircles}/></Zoom></div>
						<div className={"wallet-circles1"}><Zoom><img alt={"alt"} src={walletCircles1}/></Zoom></div>
						<div className={"wallet-circles2"}><Zoom><img alt={"alt"} src={walletCircles2}/></Zoom></div>
						<div className={"wallet-path"}><Zoom><img alt={"alt"} src={path1}/></Zoom></div>
					</>
					: null}

				<div className={"d-flex justify-content-between"}>
					<div className={this.props.page === "wallet" ? "pt-4" : "py-4"}>
						{this.props.page === "wallet" ?
							<>
								<p className={"available-amount-label mb-2"} style={{marginTop: "6px"}}>WALLET
									AMOUNT</p>
								<div className={'d-flex align-items-center'}>
									<div className={"available-amount mb-0"}>
										{
											Object.keys(walletData).length > 0 ?
												numberFormat(walletData.balance)
												// <FlipAnimation amount_value={walletData.availableNettWorth} color={"#ffffff"}/>
												: 0
										}
									</div>
									<img src={info} alt={"alt"} className={"ml-2"} style={{zIndex: 10}}
									     onClick={() => this.props.setActiveModal()}/>
								</div>
							</>
							:
							<>
								<p className={"available-amount-label mb-2"}>NET WORTH</p>
								<div className={'d-flex align-items-center'}>
									<div className={"available-amount mb-0"}>
										{
											Object.keys(walletData).length > 0 ?
												numberFormat(walletData.availableNettWorth)
												// <FlipAnimation amount_value={walletData.availableNettWorth} color={"#ffffff"}/>
												: 0
										}
									</div>
									<img src={info} alt={"alt"} className={"ml-2"} style={{zIndex: 10}}
									     onClick={() => this.props.setActiveModal()}/>
								</div>
							</>
						}

					</div>
					{this.props.page === "main" ?

						<div className={"nav-balance-image-wrap position-relative  my-3"}>
							{/*<img alt={'alt'} src={landingBanner}*/}
							{/*     className={styleLanding + "nav-balance-image my-3 mx-2"}/>*/}
							<img alt={'alt'} src={landingBannerBase}
							     className={"nav-balance-image-base"}/>
							<img alt={'alt'} src={landingBannerWallet}
							     className={"nav-balance-image-wallet "}/>
							<img alt={'alt'} src={landingBannerCoin}
							     className={"nav-balance-image-coin "}/>
						</div>
						: this.props.page === "wallet" && !(this.props.loading > 0) ?
							<div className={"wallet-bannerImage-wrap mx-2 mt-2"}>
								<div className={"wallet-bannerImage-base"}>
									<Zoom><img src={banner_base} alt={"alt"}/></Zoom>
								</div>
								<div className={"wallet-bannerImage-coin-right"}>
									<Fade bottom distance={"30px"} delay={700}><img src={banner_coin_right}
									                                                alt={"alt"}/></Fade>
								</div>
								<div className={"wallet-bannerImage-coin-left"}>
									<Fade bottom delay={900}><img src={banner_coin_left} alt={"alt"}/></Fade>
								</div>
								<div className={"wallet-bannerImage-wallet"}>
									<Fade bottom distance={"30px"} delay={500}><img src={banner_wallet}
									                                                alt={"alt"}/></Fade>
								</div>
							</div>
							: null
					}

				</div>
				{/*{this.props.page === "main" &&*/}
				{/*<div className={"d-flex align-items-center"}>*/}
				{/*	<div className={"d-flex align-items-start mr-3"}>*/}
				{/*		{ !(this.props.loading > 0) && <Zoom duration={500} delay={1000}>*/}
				{/*			<div className={"cash-type-icon-section"}>*/}
				{/*				<img src={winnings} alt={"winnings"}*/}
				{/*				     className={"img-fluid"}/>*/}
				{/*			</div>*/}
				{/*		</Zoom>}*/}
				{/*		<div className={"mx-2"}>*/}
				{/*			<p className={"cash-type-amount mb-0"}>*/}
				{/*				₹ {walletData.availableEarnings ? walletData.availableEarnings.toFixed(2) : 0}*/}
				{/*			</p>*/}
				{/*			<p className={"cash-type mb-0"}>winnings</p>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*	<div className={"d-flex align-items-start"}>*/}
				{/*		{ !(this.props.loading > 0) &&<Zoom duration={500} delay={1100}>*/}
				{/*			<div className={"cash-type-icon-section"}>*/}
				{/*				<img src={grants} alt={"grants"}*/}
				{/*				     className={"img-fluid"}/>*/}
				{/*			</div>*/}
				{/*		</Zoom>}*/}
				{/*		<div className={"mx-2"}>*/}
				{/*			<p className={"cash-type-amount mb-0"}>*/}
				{/*				₹ {walletData.availableGrantMoney ? walletData.availableGrantMoney.toFixed(2) : 0}*/}
				{/*			</p>*/}
				{/*			<p className={"cash-type mb-0"}>Bonus</p>*/}
				{/*		</div>*/}
				{/*	</div>*/}
				{/*</div>}*/}
			</MDBContainer>
		);
	}
}

const mapStateToProps = state => ({
	user_details: state.UserReducer.user_details
});

export default compose(
	withRouter,
	connect(mapStateToProps)
)(WalletCard)